var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"irc-frame loading-spinner",attrs:{"src":_vm.frameSrc}})
}
var staticRenderFns = []

export { render, staticRenderFns }